module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_0@2x.6ac32a90.png";